import { render, staticRenderFns } from "./TicketViewer.vue?vue&type=template&id=50b51912"
import script from "./TicketViewer.vue?vue&type=script&lang=js"
export * from "./TicketViewer.vue?vue&type=script&lang=js"
import style0 from "./TicketViewer.vue?vue&type=style&index=0&id=50b51912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports